// BookingContext.jsx
import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    // Trip Details
    from: '',
    to: '',
    fromCity: '',
    toCity: '',
    pickupDate: '', // Format: '2025-12-21'
    pickupTime: '', // Format: '10:00 AM'
    tripType: '',   // 'oneWay' or 'roundTrip'
    
    // Vehicle Details
    selectedVehicle: null,
    
    // Contact Details (will be filled in ContactDetailsPage)
    name: '',
    email: '',
    mobile: '',
    alternateEmail: '',
    specialInstructions: ''
  });

  // Helper to update booking data
  const updateBooking = (data) => {
    setBookingData(prev => ({ ...prev, ...data }));
  };

  return (
    <BookingContext.Provider value={{ bookingData, setBookingData, updateBooking }}>
      {children}
    </BookingContext.Provider>
  );
};